module.exports = __webpack_public_path__ + "img/premium-badge.png?6a687d0924ff5954c714be1d6c997c33";